// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".biz-title[data-v-72ff45c6] {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
